<template>
  <div v-click-outside="closeDropDown">
    <div class="toggleBtn" @click="toggleDropdown">
      <img :src="btnImage" alt="" />
      <span> </span>
    </div>
    <div class="dropdownOptions" v-show="dropDownShow">
      <div
        class="option"
        @click="linkTo('vision')"
        @mouseover="option1Image = visionWhite"
        @mouseout="option1Image = visionBlue"
      >
        <img :src="option1Image" />
      </div>
      <div
        class="option"
        @click="linkTo('chart')"
        @mouseover="option2Image = chartWhite"
        @mouseout="option2Image = chartBlue"
      >
        <img :src="option2Image" />
      </div>
    </div>
  </div>
</template>

<script>
import visionWhite from '@/assets/icon/icSwitchVisionWhite.png';
import visionBlue from '@/assets/icon/icSwitchVisionBlue.png';
import chartWhite from '@/assets/icon/icSwitchChartWhite.png';
import chartBlue from '@/assets/icon/icSwitchChartBlue.png';

export default {
  props: {
    curPage: {
      type: String,
      default() {
        return 'vision';
      },
    },
  },
  data() {
    return {
      dropDownShow: false,
      option1Image: visionBlue,
      option2Image: chartBlue,
      visionWhite,
      visionBlue,
      chartWhite,
      chartBlue,
    };
  },
  computed: {
    btnImage() {
      switch (this.curPage) {
        case 'vision':
          return visionWhite;
        case 'chart':
          return chartWhite;
        default:
          return chartWhite;
      }
    },
  },
  methods: {
    toggleDropdown() {
      this.dropDownShow = !this.dropDownShow;
    },
    closeDropDown() {
      this.dropDownShow = false;
    },
    linkTo(router) {
      this.dropDownShow = false;
      console.log(router);
      if (this.curPage !== router) {
        this.$router.replace({ path: router });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggleBtn {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 25px;
    width: 63px;
  }
  span {
    width: 20px;
    height: 20px;
    margin: 5px;
    &:after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      bottom: 9px;
      border: transparent 7px solid;
      border-top: white 10px solid;
    }
  }
}
.dropdownOptions {
  position: absolute;
  top: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  z-index: 1;
  .option {
    width: 100%;
    height: 40px;
    display: flex;
    img {
      height: 25px;
      width: 63px;
      margin: auto;
    }
    &:hover {
      background-color: #23b6bc;
    }
    &:first-child {
      border-radius: 8px 8px 0 0;
    }
    &:last-child {
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
